import {
    Grid,
    IconButton,
    withStyles
} from "@material-ui/core";
import {Field} from "formik";
import * as PropTypes from "prop-types";
import style from "./styles";
import React, {useLayoutEffect, useRef, useState} from "react";
import Button from '@material-ui/core/Button';
import {IconFechar} from '../icons/MateraIcons';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import * as classnames from 'classnames';

const InputFileBuilder = (props) => {
    const {classes, fieldSchema: schema, form} = props;
    const [img, setImg] = useState(null);
    const [file, setFile] = useState({name: ''});
    const refFileInput = useRef();

    function handleFileChange(e) {
        const imgFile = e.target?.files?.[0]
        if (imgFile) {
            schema?.onChange?.(imgFile, [img, setImg])
            setFile(imgFile)
            const reader = new FileReader();

            reader.onloadend = function () {
                setImg(reader.result);
            }
            reader.readAsDataURL(imgFile);
        } else {
            setImg('');
        }
    }

    function handleClosePreview() {
        schema?.closePreview?.([img, setImg]);
        refFileInput.current.value = null;
        if (!schema?.closePreview)
            setImg(null)
    }
    useLayoutEffect(() => {
        if(form.values[schema.field])
            schema?.onMount?.(setImg, setFile)
    }, [form.values[schema.field]])
    useLayoutEffect(() => {
            schema?.onListenerChange?.([img, setImg], handleClosePreview)
        },
        [schema.disabled, form.values[schema.listen]]
    );
    return <Grid item {...schema.sizes}>
        <Field name={schema.field} onBlur={schema.onBlur ?? form.onBlur} {...props} required={schema.isRequired}>
            {
                ({field, form}) => {
                    return <div className={classnames(classes.inputFileContainer, {disabled: schema.disabled})}>
                        <label>{schema.label}</label>
                        <Divider className={classes.divider}/>
                        <input
                            ref={refFileInput}
                            type='file'
                            style={{display: 'none'}}
                            onChange={handleFileChange}
                        />
                        {
                            !img && <Button type='button'
                                            onClick={() => refFileInput.current?.click()}
                                            variant={"outlined"}
                                            disabled={schema.disabled}>
                                Adicionar Anexo
                            </Button>
                        }
                        {
                            img && <div className={classes.imgPreviewContainer}>
                                <img src={img} alt="preview" className={classes.imgPreview}/>
                                <IconButton className={classes.imgPreviewCloseButton} size={'small'}
                                            title={schema.titleClose ?? 'Apagar'} onClick={handleClosePreview}>
                                    <IconFechar size={16}/>
                                </IconButton>
                                {
                                    file?.name &&
                                    <Typography variant={'body1'} className={classes.imgPreviewName} alt={file?.name} title={file?.name}>
                                        {file?.name}
                                    </Typography>
                                }
                            </div>
                        }
                    </div>
                    /*<TextField
                        className={classes.margin}
                        label={schema.label}
                        InputLabelProps={{
                            className: classes.label,
                            htmlFor: schema.label + '-field'
                        }}
                        InputProps={{
                            id: schema.label + '-field',
                            ...field,
                            onBlur: schema.onBlur?.(form),
                            value: field.value ?? '',
                            autoComplete: "off",
                            className: classNames(classes.margin, classes.textField),
                            disabled: schema.disabled,

                        }}
                    />*/
                }
            }
        </Field>
    </Grid>;
};


InputFileBuilder.propTypes = {
    classes: PropTypes.any,
    fieldSchema: PropTypes.any
};

export default withStyles(style)(InputFileBuilder);
